/**
 * Theme init/persist cho admin portal (US-AE.F0-0102 follow-up).
 *
 * BUG đã sửa: Topbar toggle set data-theme + lưu localStorage("gp_admin_theme"),
 * NHƯNG không nơi nào KHỞI TẠO data-theme trên <html> lúc boot, cũng không KHÔI PHỤC
 * từ localStorage. Hệ quả: mọi lần load/reload luôn về light (chưa set data-theme →
 * dùng block :root/light), toggle dark chỉ sống trong 1 phiên → "dark không work".
 *
 * CSP `script-src 'self'` KHÔNG cho inline <script> trong index.html → phải init ở đây
 * (module script, chạy trước createRoot trong main.tsx). Chấp nhận FOUC cực ngắn.
 */
export const THEME_STORAGE_KEY = "gp_admin_theme";
export type Theme = "light" | "dark";

/** Đọc theme đã lưu; nếu chưa có, theo prefers-color-scheme của hệ điều hành; mặc định light. */
export function resolveInitialTheme(): Theme {
  if (typeof document === "undefined") return "light";
  try {
    const saved = localStorage.getItem(THEME_STORAGE_KEY);
    if (saved === "dark" || saved === "light") return saved;
  } catch {
    // localStorage có thể chặn (private mode) — bỏ qua, rơi về system/light.
  }
  if (typeof window !== "undefined" && window.matchMedia) {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  }
  return "light";
}

/** Áp theme lên <html data-theme> (nguồn duy nhất mà CSS token đọc). */
function applyTheme(theme: Theme): void {
  if (typeof document === "undefined") return;
  document.documentElement.setAttribute("data-theme", theme);
}

/** Gọi 1 lần lúc boot (main.tsx) trước khi render để tránh flash sai theme. */
export function initTheme(): Theme {
  const theme = resolveInitialTheme();
  applyTheme(theme);
  return theme;
}

/** Lưu + áp theme (dùng bởi toggle). */
export function persistTheme(theme: Theme): void {
  applyTheme(theme);
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    // Không lưu được vẫn áp trong phiên — không chặn UX.
  }
}
